import React, { useEffect } from "react";
import { IconClose } from "./toolbarIcons";

export function FormModalShell({ open, title, subtitle, onClose, children, actions }) {
  useEffect(() => {
    if (!open) return undefined;

    function handleKeyDown(event) {
      if (event.key === "Escape") onClose();
    }

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="confirm-modal-backdrop" role="presentation" onClick={onClose}>
      <div className="record-view-modal" role="dialog" aria-modal="true" onClick={(event) => event.stopPropagation()}>
        <div className="record-view-modal__header">
          <div>
            <h3>{title}</h3>
            {subtitle ? <p>{subtitle}</p> : null}
          </div>
          <button type="button" className="record-view-modal__close" onClick={onClose} aria-label="Close modal">
            <IconClose />
          </button>
        </div>
        <div className="record-view-modal__body">
          {children}
          {actions ? <div className="confirm-modal-actions">{actions}</div> : null}
        </div>
      </div>
    </div>
  );
}
